import { DropdownContent } from '@anm/components/Dropdown';
import TitleBlock from '@anm/components/TitleBlock';
import { TooltipContent } from '@anm/components/Tooltip';
import { flexCenter, flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { subTitleStyles, tabTitleStyles } from '../../Wrapper';

import { ContainerProps, ContentDataProps } from './types';

const ENGAGEMENT_RIGHT_GAP = '48px';

export const RelativeBlock = styled.div`
  position: relative;
`;

export const ChartTitleWrapper = styled.div`
  ${flexRow};
  ${flexCenter};
`;

const chartTitleOnMobile = media.phone`
  display: block;
`;

export const ChartTitle = styled(TitleBlock)`
  ${tabTitleStyles};
  width: unset;
  margin-bottom: 1px;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 17px;
  }
  ${chartTitleOnMobile};
`;

export const TitleRow = styled.div<{ maxWidth?: number }>`
  ${flexRow};
  align-items: center;
  margin: 18px 0 17px;
  justify-content: space-between;
  ${TooltipContent} {
    padding: 16px 15px 18px 20px;
    transform: translate(50%, calc(-100% - 10px));
    min-width: 240px;
  }
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth}px;
      margin-right: 0;
    `}
`;

const datePickerAndButtonWrapperOnMobile = media.phone`
  padding: 0;
  ${flexColumn};
  button {
    margin-top: 10px;
  }
`;

export const DatePickerAndButtonWrapper = styled.div`
  ${flexRow};
  margin-bottom: 15px;
  padding-right: 50px;
  justify-content: space-between;
  button {
    margin-top: auto;
  }
  ${datePickerAndButtonWrapperOnMobile};
  @media (max-height: 415px) and (orientation: landscape) {
    width: 100%;
    padding: 0;
  }
`;

export const DateLabel = styled(TitleBlock)`
  ${subTitleStyles};
  margin-bottom: 8px;
`;

const datePickerWrapperOnMobile = media.phone`
  min-width: 100%;
 `;

export const DatePickerWrapper = styled.div`
  min-width: 360px;
  min-height: 65px;
  ${DropdownContent} {
    left: 0;
    transform: none;
  }
  ${datePickerWrapperOnMobile}
`;

const contentWrapperOnMobile = media.phone`
  margin: 0;
  margin: 20px;
`;

export const ContentWrapper = styled.div`
  margin: 11px -8px 0 -26px;
  ${contentWrapperOnMobile};
  @media (max-height: 415px) and (orientation: landscape) {
    margin: 0;
    ${flexColumn};
    ${flexCenter};
    padding: 0 20px;
  }
`;

const chartWrapperOnMobile = media.phone`
  ${flexColumn};
`;

export const ChartsWrapper = styled.div`
  ${flexRow};
  ${chartWrapperOnMobile};

  @media (max-height: 415px) and (orientation: landscape) {
    ${flexColumn};
  }
`;

const contentOnMobile = media.phone`
  padding: 0;
  width: 100%;
  margin-bottom: 24px;
`;

export const EngagementWrapper = styled.div<ContainerProps>`
  padding-right: ${ENGAGEMENT_RIGHT_GAP};
  video {
    max-width: 100%;
  }
  width: calc(${({ isVerticalVideo }) => (isVerticalVideo ? 30 : 40)}% + ${ENGAGEMENT_RIGHT_GAP});
  ${contentOnMobile};
  @media (max-height: 415px) and (orientation: landscape) {
    padding: 0;
    width: 100%;
    margin-bottom: 15px;
    & > div {
      margin: 0;
    }
  }
`;

export const PlayerChartsContent = styled.div<ContainerProps>`
  width: calc(${({ isVerticalVideo }) => (isVerticalVideo ? 70 : 60)}% - ${ENGAGEMENT_RIGHT_GAP});
  & > div {
    margin-bottom: 38px;
  }
  ${contentOnMobile};
  @media (max-height: 415px) and (orientation: landscape) {
    width: 100%;
    margin-top: 20px;
  }
`;

export const ContentDataWrapper = styled(RelativeBlock)<ContentDataProps>`
  ${flexCenter};
  border: 1px solid #ccdde6;
  max-width: ${({ maxWidth }) => maxWidth}px;
  height: ${({ height }) => height}px;
`;

export const InfoMessage = styled.p<{ maxWidth: number }>`
  line-height: 22px;
  text-align: center;
  max-width: ${({ maxWidth }) => maxWidth}px;
  a {
    color: var(--blue_100);
    cursor: pointer;
  }
`;
